import { makeAutoObservable } from 'mobx';
import { WeekDay } from '../utils/date-format';
import { TimeFormat } from '../utils/time-format';
import { UserSummaryType } from '../api/types/user/user-summary.type';
import { ClassMetadata } from '../api/types/settings/branches/buildings/classes/class-metadata';
import { CalenderModel } from '../api/types/calender/calender-model';
import {
  ScheduleDetailsDetails,
  ScheduleDetailsType,
} from '../api/types/calender/class-schedule/schedule/schedule-details-details';
import { ClassScheduleModel } from '../api/types/calender/class-schedule/class-schedule-model';
import { BaseEntity } from '../api/types/base-entity';
import { LectureWithScheduleMetadata } from '../api/types/programs/course/lectures/lecture-with-schedule-metadata';

const asd: ScheduleDetailsDetails = {
  type: ScheduleDetailsType.lecture,
  data: {
    id: 1,
    lectureParts: [
      {
        id: 1,
        startTime: new Date(2025, 2, 12, 14, 0),
        endTime: new Date(2025, 2, 12, 15, 0),
        durationMinutes: 60,
      },
      {
        id: 1,
        startTime: new Date(2025, 2, 12, 14, 0),
        endTime: new Date(2025, 2, 12, 15, 0),
        durationMinutes: 100,
      },
    ],
    lectureSubject: 'Lecture subject',
    createdByName: '',
    createdAt: new Date(),
    createdBy: 1,
  },
};

const entity: BaseEntity = {
  createdAt: new Date(),
  createdBy: 1,
  createdByName: 'string',
};
const classesFilterr: ClassMetadata[] = [
  {
    id: 1,
    className: 'asd1',
    attributes: [],
    ...entity,
  },
  {
    id: 2,
    className: 'asd2',
    attributes: [],
    ...entity,
  },
  {
    id: 3,
    className: 'asd3',
    attributes: [],
    ...entity,
  },
  {
    id: 4,
    className: 'asd4',
    attributes: [],
    ...entity,
  },
];

export interface IterationSchedulingDates {
  startTime: Date;
  endTime: Date;
}

export interface IterationScheduling {
  startTime: TimeFormat;
  endTime: TimeFormat;
  iterationNumber: number;
  dates: IterationSchedulingDates[];
}

class GlobalLectureBuilderStore {
  // Lectures iteration inputs
  iterationStartDate: Date = new Date();
  iterationDays: Set<WeekDay> = new Set<WeekDay>();
  iterationNumber = 0;
  iterationScheduling: Map<WeekDay, IterationScheduling> = new Map();

  // Course lecturers
  courseLecturer: UserSummaryType[] = [];

  // classesFilters
  filterClasses: ClassMetadata[] = classesFilterr;

  // Calendar response
  calenderResponse?: CalenderModel;

  // Current tab day selected
  currentSelectedDayTab: WeekDay = WeekDay.Monday;

  selectedSchedule: Map<string, { classMetadata: ClassMetadata; date: Date }> =
    new Map();

  selectedLecture: LectureWithScheduleMetadata | null = null;

  constructor() {
    makeAutoObservable(this);
  }
}
const globalLectureBuilderStore = new GlobalLectureBuilderStore();
export default globalLectureBuilderStore;
